<template>
    <div id="lm-form-builder-ui" class="wrapper-content w-100">
      <h1>FormBuilderUi</h1>
      <div class="row position-relative">
        <LmComponentLoading v-if="isLoading" fixed />
        <div class="col-12 col-md-3">
            <!-- <router-link to="/FormBuilderUi/" class="d-block">Nuevo</router-link> -->
            <!-- No recarga el componente FormBuilderUi y genera error con los datos previos -->
            <a :href="$router.resolve('/FormBuilderUi').href" class="d-block">Nuevo</a>
            <router-link :to="`/FormBuilderUi/edit/${currentID}`" class="d-block mt-2">Editar {{currentID}}</router-link>
            <router-link :to="`/FormBuilderUi/preview/${currentID}`" class="d-block mt-2">Preview {{currentID}}</router-link>
        </div>
        <div class="col-12 mt-3">
          <b-form-group label="Modos">
            <b-form-radio-group
              id="btn-modos"
              v-model="modes.selected"
              :options="modes.options"
              buttons
              button-variant="primary"
              @change="modes.editView = $event === 'edit'"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6" v-show="modes.editView">
          <LmForm ref="lmFormRef" id="form-builder-ui-form">
            <LmTextInput
              class="col-12"
              v-model="form.pageTitleData"
              :v="$v.form.pageTitleData"
              label="Titulo del formulario" />
            <LmTextInput
              class="col-12 col-md-6"
              id="input-alias"
              v-model="form.alias"
              :v="$v.form.alias"
              label="Alias" />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.apiRestForHandleAllHttpMethods"
              :v="$v.form.apiRestForHandleAllHttpMethods"
              label="Path api rest para manejar GET, POST Y UPDATE"
              :isApiPath="true"
              />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.messageAfterPOSTorPUT"
              label="Mensage post guardado" />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.pathToRedirectAfterPOSTorPUT"
              label="Post guardado redireccionar a este path" />
            <LmUserPermissions
              :form="form"
            />
            <draggable
              class="col-12"
              v-model="form.formElements"
              @start="drag=true"
              @end="drag=false"
              >
              <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4 border border-primary">
                <header
                  class="d-flex justify-content-between align-items-center bg-primary text-white pr-3 pl-3"
                  :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                  <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                  <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center">{{title(form.formElements[index])}}</h4>
                  <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div>
                    <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" />
                    <font-awesome-icon v-if="form.formElements.length > 1" class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" />
                  </div>
                </header>
                <b-collapse
                  accordion="my-accordion"
                  :id="`collapse-${index}`"
                  visible
                  class="p-4"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="form.formElements[index].componentName"
                    :options="generator.selectorElementTypeOptions"
                    label="Seleccione el tipo de elemento"
                    @input="selectorElementForm($event, index)"
                  />
                  <component
                    :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                    :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                    :componentData="form.formElements[index]"
                    :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                    :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                    :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                    :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                    :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                    :options="lmSuperPowerSelectV2BuilderUiOptions"
                    :isOnEditMode="isOnEditMode"
                    @input="inputHandler($event, index)"
                    @validations-changes="validationsChangesHandler"
                  />
                </b-collapse>
              </div>
            </draggable>
            <p v-if="$v.$error && !$v.form.formElements.required" class="invalid-feedback d-block">El formulario debe tener al menos un elemento.</p>
            <div class="col-12">
              <LmButton
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addFormElement(form.formElements.length)"
                value="Agregar un campo al formulario"
              />
            </div>
          </LmForm>
        </div>
        <div class="col-12" :class="{ 'col-md-6': modes.editView }">
          <LmFormBuilder
            :getComponents="form"
            :isOnPreviewMode="modes.editView"
            @openEditFormElement="openEditFormElement"
          />
        </div>
        <div class="col-12 mt-4" v-show="modes.editView">
          <LmButton
            :disabled="isDisabledByUserPrivileges()"
            id="submit-button"
            type="button"
            :value="$t('Save')"
            buttonClass="btn-primary"
            lmButtonRootWrapperClass="d-inline-block"
            @click.native="submit"/>
        </div>
        <p
          v-if="isDisabledByUserPrivileges()"
          class="font-italic text-danger"
        >
          Lo sentimos, no tiene permisos para guardar los cambios.
        </p>
      </div>
    </div>
</template>

<script>
import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmSelect from '@/components/form/elements/LmSelect'
import draggable from 'vuedraggable'
import LmFormBuilder from '@/components/LmFormBuilder'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUserPermissions from '@/components/lmFormBuilderUi/LmUserPermissionsUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'

import commonsApi from '@/api/commons'
import { required } from 'vuelidate/lib/validators'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

import { checkUserPermissions } from '@/helpers/userPermissions'

export default {
  mixins: [lmToasts, lmFormBuilderUi],
  data () {
    return {
      isLoading: false,
      currentID: this.$route?.params?.id || '',
      modes: {
        selected: 'edit',
        options: [
          { text: '✏ Editar', value: 'edit' },
          { text: 'Preview 🥽', value: 'preview' }
        ],
        editView: true
      },
      form: {
        alias: '',
        pageTitleData: '',
        messageAfterPOSTorPUT: '',
        pathToRedirectAfterPOSTorPUT: '',
        apiRestForHandleAllHttpMethods: '',
        allowAccess: [],
        allowCreate: [],
        allowUpdate: [],
        validations: {},
        formElements: []
      },
      initialForm: {},
      viewPermissions: {
        allowAccess: process?.env?.VUE_APP_FORM_FORMBUILDERUI_ALLOW_PERMISSIONS.split(',') || [],
        allowCreate: process?.env?.VUE_APP_FORM_FORMBUILDERUI_ALLOW_PERMISSIONS.split(',') || [],
        allowUpdate: process?.env?.VUE_APP_FORM_FORMBUILDERUI_ALLOW_PERMISSIONS.split(',') || []
      },
      userPrivileges: {}
    }
  },
  validations: {
    form: {
      pageTitleData: {
        required
      },
      alias: {
        required
      },
      apiRestForHandleAllHttpMethods: {
        required
      },
      formElements: {
        required
      }
    }
  },
  computed: {
    previewView () {
      return !this.modes.editView
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmButton,
    LmSelect,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmFormBuilder,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUserPermissions,
    LmUploadFilesBuilderUi,
    LmImportFromExcelBuilderUi
  },
  methods: {
    isDisabledByUserPrivileges () {
      // Crear
      if (!this.userPrivileges.allowCreate && !this.isOnEditMode) {
        return true
      }
      // Actualizar
      if (!this.userPrivileges.allowUpdate && this.isOnEditMode) {
        return true
      }
      return false
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'formbuilder',
          id: this.$route.params.id,
          paramsMode: true
        })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.$refs.lmFormRef.showLoading()
        setTimeout(() => {
          this.$v.$reset()
          this.$refs.lmFormRef.hideLoading()
        }, 350)
      }
    },
    async submit () {
      await this.$refs.lmFormRef.validationForm(this.$v)
      try {
        this.isLoading = true
        this.form.messageAfterPOSTorPUT = this.form.messageAfterPOSTorPUT || 'Guardada'
        this.form.pathToRedirectAfterPOSTorPUT = this.form.pathToRedirectAfterPOSTorPUT || '/'
        if (this.isOnEditMode) {
          const response = await commonsApi.axiosPutWrapper(`formbuilder/${this.$route.params.id}`, this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/FormBuilderUi/preview/${this.currentID}`, 'Puedes ver el formulario aquí', 'Se guardó exitosamente')
        } else {
          const response = await commonsApi.axiosPostWrapper('formbuilder/create', this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/FormBuilderUi/preview/${this.currentID}`, 'Puedes ver el  formulario aquí', 'Se guardó exitosamente')
        }
      } finally {
        this.isLoading = false
        this.$router.push('/listFormBuilder')
      }
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.generator.selectorElementTypeOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    }
  },
  created () {
    // Check user permissions
    this.userPrivileges = checkUserPermissions(this.viewPermissions)
    if (!this.userPrivileges.allowAccess) {
      this.$router.push('/')
    }

    this.initialForm = JSON.stringify(this.form)
  },
  async mounted () {
    this.setForm()
  },
  beforeDestroy () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  #form-builder-ui-form
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    margin-right: -15px
    margin-left: -15px
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
#lm-form-builder-ui
  .bars
    &:hover
      cursor: grab
::v-deep
  #LmFormBuilder
    padding: 0
</style>
